// @ts-nocheck
import React from "react";
import Rating from "react-rating";
import { AiOutlineStar, AiFillStar } from "react-icons/ai";

interface PropTypes {
  rating: number;
  ratingcount?: number;
  fontSize?: string;
}

const RatingComponent = ({ rating, ratingcount, fontSize }: PropTypes) => {
  return (
    <div className="flex flex-row items-center md:justify-center">

      <p className="">{rating?.toFixed(1)} </p>

      <div className='mt-1 ml-1'>
        <Rating
          fullSymbol={
            <AiFillStar
              color="gold"
              fontSize={fontSize ? fontSize : "1rem"}
              className=""
            />
          }
          emptySymbol={
            <AiOutlineStar
              fontSize={fontSize ? fontSize : "1rem"}
              className=""
            />
          }
          initialRating={rating}
          readonly
        />

      </div>
    </div>
  );
};

export default RatingComponent;
